module.exports = __webpack_public_path__ + "1b2c9d1c75c0a31c6eb854f69b2a378b.png";